const TopicOne = () => {
  return (
    <div>
      {/* <div className="quality-section-market">
        <div className="quality-header-market">
          <p>
            At The Pips, safeguarding your trading experience is one of our
            highest priorities. In a digital world where online transactions and
            data-sharing happen every second, understanding how to protect
            yourself from scams, fraud, and cyber-attacks is essential. This
            page will guide you through the most common security threats, how to
            avoid them, and the steps to take if you ever need to report
            suspicious activity.
          </p>
        </div>
      </div> */}
      <div className="quality-section-market">
        <div className="quality-header-market">
          <h1>Your Funds, Secured at Every Step</h1>
          <p>
            We prioritise the safety of your deposits and withdrawals with
            strict verification, encrypted transactions, and compliant financial
            procedures, so your money always moves safely and only at your
            command.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TopicOne;
